import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  CHECK_PENDING_DOCS_ALERT_REQUEST,
  CHECK_PENDING_DOCS_ALERT_SUCCESS,
  CHECK_PENDING_DOCS_ALERT_FAILURE,
} = documentationActions;

function* checkPendingDocsAlert(action: any): SagaReturnType<any> {
  try {
    const response = yield call(templateService.checkPendingDocsAlert, action.payload);
    if (response?.status === 200) {
      yield put({ type: CHECK_PENDING_DOCS_ALERT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CHECK_PENDING_DOCS_ALERT_FAILURE, payload: error });
  }
}

function* checkPendingDocsAlertSaga() {
  yield takeEvery(CHECK_PENDING_DOCS_ALERT_REQUEST, checkPendingDocsAlert);
}

export default checkPendingDocsAlertSaga;
